const INTERVAL = 1.5; // seconds
const TOTAL_DURATION = 6; // 4 cards × 1.5s

const KeyFeatures = () => {
  const features = [
    {
      id: 1,
      image: '/assets/aida/3section-1.svg',
      title: 'AI-Driven Data Extraction',
      description:
        'Extracts key data points from structured and unstructured documents with high precision.',
    },
    {
      id: 2,
      image: '/assets/aida/3section-2.svg',
      title: 'Human-in-the-Loop Validation',
      description:
        'Ensures accuracy and compliance by incorporating human review where necessary.',
    },
    {
      id: 3,
      image: '/assets/aida/3section-3.svg',
      title: 'Automated Workflow Processing',
      description:
        'Seamlessly integrates with enterprise systems to automate document processing workflows.',
    },
    {
      id: 4,
      image: '/assets/aida/3section-4.svg',
      title: 'Natural Language Processing (NLP)',
      description:
        'Understands and interprets textual data for enhanced decision-making.',
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 light-blue-bg">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12 lg:mb-14">
          <h2 className="font-bold mb-4 md:mb-5">
            <span className="">Key </span>
            <span className="secondary-text">Features</span>
          </h2>
          <p className="   max-w-4xl mx-auto px-4 leading-relaxed">
            Discover how AiDA transforms complex, unstructured data into clear,
            actionable insights through automation and intelligence.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-6 lg:gap-7">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="card-animate bg-white rounded overflow-hidden shadow cursor-pointer"
              style={{
                animationDelay: `-${index * INTERVAL}s`,
              }}
            >
              <div className="relative h-50 md:h-54 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="p-4 md:p-5 text-center">
                <h3 className="   font-bold">
                  {feature.title}
                </h3>
                <p className="text-gray-600   leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ✅ CORRECT SEQUENTIAL POP */}
      <style jsx>{`
        :global(.card-animate) {
          transform: scale(1);
          animation: popSequence ${TOTAL_DURATION}s ease-in-out infinite;
          will-change: transform;
        }

        @keyframes :global(popSequence) {
          /* idle */
          0%,
          80%,
          100% {
            transform: scale(1);
          }

          /* pop */
          10% {
            transform: scale(1.08);
          }

          /* back */
          20% {
            transform: scale(1);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          :global(.card-animate) {
            animation: none;
          }
        }
      `}</style>
    </section>
  );
};

export default KeyFeatures;
